/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Seo_News_Description1Inputs */

const vi_sitesettings_seo_news_description1 = /** @type {(inputs: Sitesettings_Seo_News_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mô tả trang Tin tức`)
};

/**

* @param {Sitesettings_Seo_News_Description1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_seo_news_description1 = /** @type {((inputs?: Sitesettings_Seo_News_Description1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Seo_News_Description1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_seo_news_description1(inputs)
});
export { sitesettings_seo_news_description1 as "siteSettings_seo_news_description" }